module.exports = __webpack_public_path__ + "static/media/26UNRWA17.b84b6db0.jpg";